export default {
  namespaced: true,
  state: {
    investors: JSON.parse(localStorage.getItem('investors') || '[]')
  },
  mutations: {
    SET_INVESTORS: (state, value) => {
      localStorage.setItem('investors', JSON.stringify(value));
      state.investors = value;
    }
  },
  actions: {
    setInvestors: ({ commit }, investors) => {
      commit('SET_INVESTORS', investors);
    }
  },
  getters: {
    investors: ({ investors }) => investors
  }
};
